import { layers, namedFlavor } from '@protomaps/basemaps'
import type { StyleSpecification } from 'maplibre-gl'

export const DEFAULT_MAPS_BASEMAP_URL = 'https://maps.johku.com/basemap'
export const DEFAULT_MAP_CENTER = { lat: 60.17181876023031, lng: 24.941196491601545 }
export const BASEMAP_SOURCE_ID = 'basemap'
export const BASEMAP_MAX_ZOOM = 15
export const BASEMAP_VIEW_MAX_ZOOM = 18

const BASEMAP_LANGS = new Set([
  'ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fa', 'fi', 'fr', 'ga', 'he',
  'hi', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'lt', 'lv', 'mr', 'mt', 'ne', 'nl', 'no',
  'pl', 'pt', 'ro', 'ru', 'sk', 'sl', 'sv', 'tr', 'uk', 'ur', 'vi', 'zh'
])

export function mapsBasemapTilesUrl (configured?: string | null): string {
  const raw = String(configured || DEFAULT_MAPS_BASEMAP_URL).trim().replace(/\/$/, '')
  if (raw.includes('{z}')) {
    return raw
  }
  return raw + '/{z}/{x}/{y}'
}

export function basemapLang (locale?: string | null): string {
  const short = String(locale || 'en').split(/[_-]/)[0].toLowerCase()
  if (short === 'nb' || short === 'nn') {
    return 'no'
  }
  return BASEMAP_LANGS.has(short) ? short : 'en'
}

export function createBasemapStyle (options: {
  tileUrl?: string | null
  lang?: string | null
} = {}): StyleSpecification {
  return {
    version: 8,
    glyphs: 'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf',
    sprite: 'https://protomaps.github.io/basemaps-assets/sprites/v4/light',
    sources: {
      [BASEMAP_SOURCE_ID]: {
        type: 'vector',
        tiles: [mapsBasemapTilesUrl(options.tileUrl)],
        maxzoom: BASEMAP_MAX_ZOOM,
        attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    },
    layers: layers(BASEMAP_SOURCE_ID, namedFlavor('light'), { lang: basemapLang(options.lang) })
  }
}

export function productCoordinates (product: Record<string, any> | null | undefined): { lat: number, lng: number } | null {
  if (!product) {
    return null
  }
  const geo = product.geo
  if (Array.isArray(geo) && geo.length >= 2) {
    const lat = parseFloat(geo[0])
    const lng = parseFloat(geo[1])
    if (lat && lng) {
      return { lat, lng }
    }
  }
  const lat = parseFloat(product.channeldata?.latitude ?? product.latitude ?? product.lat)
  const lng = parseFloat(product.channeldata?.longitude ?? product.longitude ?? product.lng)
  if (lat && lng) {
    return { lat, lng }
  }
  const availabilityLat = parseFloat(product.availability?.lat)
  const availabilityLng = parseFloat(product.availability?.lng)
  if (availabilityLat && availabilityLng) {
    return { lat: availabilityLat, lng: availabilityLng }
  }
  return null
}
